import { IAppeal, AppealSchema } from "@app/api/appeals/helper-schemas";
import { RawInstances, createCRUDActionTypes, createModel } from "m-model-core";
import {
	getDefaultStorageSettings,
	filterByLoadTime,
	loadFromStorage,
	listenToLocalStorageChange,
	getDefaultReducer,
} from "m-model-common";
import { MAX_LOAD_TIME_DIFF, MIN_LOAD_TIME } from "./constants";
import { store } from "index";
import { validateStorage, getJoiObjectKeys } from "m-model-joi";
import { CourseCommonMetaInfo } from "./meta-info";

const keyOfId = "_id";
type IdKey = typeof keyOfId;
type DOC = IAppeal;
export type IStateAppeals = RawInstances<IdKey, DOC>;

// ==============Base Model=================

const dockeys = getJoiObjectKeys<DOC>(AppealSchema);
const storage = localStorage;
const actionTypes = createCRUDActionTypes("appeal");
const storageSettings = getDefaultStorageSettings("appeals");
const metaInformationName = "appealsMetaInformation";

const isLoadedRecentlyEnough = filterByLoadTime(
	MAX_LOAD_TIME_DIFF,
	MIN_LOAD_TIME
);

const Model = createModel<IdKey, DOC>({
	keyOfId,
	getInstances: (() => store.getState().appeals) as any,
	dispatch: (action => store.dispatch(action)) as any,
	subscribe: (listener => store.subscribe(listener)) as any,
	actionTypes,
	dockeys,
	loadInstancesFromStorage: () =>
		loadFromStorage({
			storage,
			key: storageSettings.itemName,
			validateWholeData: validateStorage("ObjectId", AppealSchema),
			filter: isLoadedRecentlyEnough,
		}),
});

// ==============Main Model=================

export class Appeal extends Model {
	static initialize() {
		const info = super.initialize();
		if (info.loadedAll) this.meta.initialize();
		else this.meta.clear();
		return info;
	}

	static meta = new CourseCommonMetaInfo(storage, metaInformationName);
}

export type IAppealInstance = Appeal;
export type IAppealModel = typeof Appeal;

// ==============ETC=================

listenToLocalStorageChange(storage, metaInformationName, Appeal.meta);

export const appealsReducer = getDefaultReducer(storageSettings, () => Appeal);
